import { GoogleMerchantSyncRunMode } from '@/models/googleMerchantSync.model';
import { Dayjs } from 'dayjs';

export enum GoogleMerchantSyncFormFields {
  MODE = 'mode',
  SINCE = 'since',
  PRODUCT_SKU = 'sku',
}

export type TGoogleMerchantFullSyncFormValues = {
  [GoogleMerchantSyncFormFields.MODE]: GoogleMerchantSyncRunMode.FULL;
};

export type TGoogleMerchantDeltaSyncFormValues = {
  [GoogleMerchantSyncFormFields.MODE]: GoogleMerchantSyncRunMode.DELTA;
  [GoogleMerchantSyncFormFields.SINCE]: Dayjs;
};

export type TGoogleMerchantProductSyncFormValues = {
  [GoogleMerchantSyncFormFields.MODE]: GoogleMerchantSyncRunMode.PRODUCT;
  [GoogleMerchantSyncFormFields.PRODUCT_SKU]: string;
};

export type TGoogleMerchantSyncFormValues =
  | TGoogleMerchantFullSyncFormValues
  | TGoogleMerchantDeltaSyncFormValues
  | TGoogleMerchantProductSyncFormValues;
